import type { CreateSpaceRequest } from '@/types/api/requests'
import type {
  SpaceResponse,
  SpaceSummaryResponse,
  SpaceStatisticsResponse,
  AnalysisUsageResponse,
} from '@/types/api/responses'
// import type { components } from '@/types/openapi' // 未使用のためコメントアウト
import { apiFetcher } from '@/api/api-fetcher'

export async function createSpace(request: CreateSpaceRequest) {
  return apiFetcher.securePost<SpaceResponse>('/spaces', request)
}

export async function getSpaces() {
  return apiFetcher.secureGet<SpaceSummaryResponse[]>('/spaces')
}

/**
 * @deprecated このAPIエンドポイント(/users/${userId}/spaces)は削除されました
 * 代替手段として getSpaces() を使用し、クライアント側でフィルタリングを行うか、
 * 管理者権限が必要な場合は admin.getSpaceUsers() を使用してください
 */
export async function getUserSpaces(_userId: string) {
  // 削除されたエンドポイントの使用を防ぐため、エラーを投げる
  throw new Error(
    'getUserSpaces API has been removed. Use getSpaces() and filter on client side, ' +
      'or use admin.getSpaceUsers() for admin operations.'
  )

  // 旧実装（削除されたため使用不可）
  // return apiFetcher.get<SpaceResponse[]>(`/users/${userId}/spaces`)
}

/**
 * 現在のユーザーがアクセス可能なスペース一覧を取得
 * getUserSpaces の安全な代替実装
 */
export async function getCurrentUserSpaces(): Promise<SpaceSummaryResponse[]> {
  // 現在のユーザーがアクセス可能なスペースのみが返される
  return apiFetcher.secureGet<SpaceSummaryResponse[]>('/spaces')
}

export async function updateSpace(spaceId: string, request: CreateSpaceRequest) {
  return apiFetcher.securePut<SpaceResponse>(`/spaces/${spaceId}`, request)
}

export async function deleteSpace(spaceId: string) {
  return apiFetcher.secureDelete<void>(`/spaces/${spaceId}`)
}

export async function getSpaceStatistics(spaceId: string) {
  return apiFetcher.secureGet<SpaceStatisticsResponse>(`/spaces/${spaceId}/statistics`)
}

export async function getAnalysisUsage(spaceId: string, featureType: string = 'ANALYSIS') {
  return apiFetcher.secureGet<AnalysisUsageResponse>(`/spaces/${spaceId}/analysis-usage`, {
    params: { featureType },
  })
}
